export default {
  en: {
    title: 'Edit Company',
    subtitle: 'Change your company\'s data.',
    button: 'Save changes',
    form: {
      name: 'Business Name',
      dni: 'Tax ID',
      address: 'Address',
      country: 'Country',
      admin: 'Administrator',
      lang: 'Language',
    },
    helpers: {
      dni: 'This is the taxpayer identification number of your business.',
      address: 'Fill with the your current country, not the main headquarters.',
      country: 'Select your country not the main headquarters.',
      admin: 'This is the principal administrator who have the control over account and others administrators.',
      lang: 'This is the default language for every user, although every user can select different language of the default.',
    },
    errors: {
      name: 'Please fill with a valid name',
      dni: 'Please fill with a valid business id',
      address: 'Please fill with a valid address',
      country: 'Please select a country',
      admin: 'Please select an administrator',
      lang: 'Please select a language',
      unknown: 'Something goes wrong, please try again.',
    },
    success: 'Account modification successful',
  },
  es: {
    title: 'Modificar Empresa',
    subtitle: 'Cambie datos de su empresa.',
    button: 'Guardar cambios',
    form: {
      name: 'Nombre Empresa',
      dni: 'DNI/Tax ID',
      address: 'Dirección',
      country: 'País',
      admin: 'Administrador',
      lang: 'Idioma',
    },
    helpers: {
      dni: 'Esta es el número de identificación tributaria nacional de su negocio.',
      address: 'Complete con su país actual, no con la sede principal.',
      country: 'Seleccione su país, no la sede principal.',
      admin: 'Este es el administrador principal que tiene el control sobre la cuenta y otros administradores.',
      lang: 'Este es el idioma predeterminado para cada usuario, aunque cada usuario puede seleccionar un idioma diferente al predeterminado.',
    },
    errors: {
      name: 'Por favor complete con un nombre válido',
      dni: 'Rellene con una identificación del negocio válido',
      address: 'Por favor complete con una dirección válida',
      country: 'Por favor seleccione un país',
      admin: 'Por favor seleccione un administrador',
      lang: 'Por favor seleccione un idioma',
      unknown: 'Something goes wrong, please try again.',
    },
    success: 'Los datos han sido modificados correctamente',
  },
};
